// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#home-main-container .w-75 {
  width: 75%;
}
#home-main-container .w-25 {
  width: 25%;
}
#home-main-container #paper-gray-border.MuiPaper-root {
  border: 0.5px solid #909bb3;
  border-radius: 8px;
  width: 100%;
  font-family: "Source Sans Pro", sans-serif;
  color: #373f50;
}
#home-main-container .welcome-card-container {
  min-height: 143px;
  padding-top: 35px;
  color: #373f50;
  font-family: Source Sans Pro, sans-serif;
  display: flex;
  flex-flow: column nowrap;
  align-items: flex-start;
}
@media (max-width: 750px) {
  #home-main-container .welcome-card-container {
    align-items: center;
  }
  #home-main-container .welcome-card-container div {
    text-align: center;
  }
}
#home-main-container .welcome-card-container .name-container {
  font-size: 48px;
  display: inline-block;
  max-width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
#home-main-container #dj-uni-card-container #paper-gray-border.MuiPaper-root {
  padding: 21px 50px 20px 24px;
}
@media (max-width: 1500px) {
  #home-main-container #dj-uni-card-container #paper-gray-border.MuiPaper-root {
    padding-right: 20px;
  }
}
#home-main-container #dj-uni-card-container .flex-container {
  display: flex;
  flex-flow: column nowrap;
  align-items: flex-start;
}
#home-main-container #dj-uni-card-container .flex-container .card-header {
  font-family: "Source Sans Pro", sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  line-height: 30px;
  letter-spacing: 0.0015em;
  color: #373f50;
  margin-bottom: 9px;
}
#home-main-container #dj-uni-card-container .flex-container .body-text {
  font-family: "Source Sans Pro", sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  letter-spacing: 0.0015em;
  color: #373f50;
}
#home-main-container #dj-uni-card-container .flex-container .body-text .card-link {
  color: #008cce;
  font-weight: 600;
  cursor: pointer;
}
@media (max-width: 1500px) {
  #home-main-container #dj-uni-card-container .flex-container {
    flex-flow: row nowrap;
    align-items: center;
  }
  #home-main-container #dj-uni-card-container .flex-container .icon-hyperlink {
    margin-bottom: 0px;
    min-width: 200px;
  }
  #home-main-container #dj-uni-card-container .flex-container .card-header {
    white-space: nowrap;
    font-size: 16px;
    margin-right: 10px;
  }
  #home-main-container #dj-uni-card-container .flex-container .body-text {
    text-align: justify;
  }
}
@media (max-width: 750px) {
  #home-main-container #dj-uni-card-container .flex-container {
    flex-flow: column nowrap;
    align-items: flex-start;
  }
  #home-main-container #dj-uni-card-container .flex-container .icon-hyperlink {
    margin-bottom: 14px;
  }
}
#home-main-container #video-card-container #paper-gray-border.MuiPaper-root {
  padding: 20px 0px 28px 20px;
}
@media (max-width: 1279px) {
  #home-main-container #video-card-container #paper-gray-border.MuiPaper-root {
    padding-left: 20px;
  }
}
@media (max-width: 650px) {
  #home-main-container #video-card-container #paper-gray-border.MuiPaper-root {
    padding: 20px 20px 28px 20px;
    display: flex;
    flex-flow: column nowrap;
    align-items: center;
  }
  #home-main-container #video-card-container #paper-gray-border.MuiPaper-root div {
    text-align: justify;
  }
  #home-main-container #video-card-container #paper-gray-border.MuiPaper-root #video-card-header {
    align-self: flex-start;
  }
}
@media (max-width: 650px) {
  #home-main-container #video-card-container #paper-gray-border.MuiPaper-root #video-blue-paper-wrapper {
    width: 100%;
    display: flex;
    flex-flow: column nowrap;
    align-items: center;
  }
}
#home-main-container #video-card-container #paper-gray-border.MuiPaper-root #paper-blue-border.MuiPaper-root {
  border: 1px solid #008cce;
  margin: 20px 0px;
  width: 81%;
  border-radius: 8px;
}
#home-main-container #video-card-container #paper-gray-border.MuiPaper-root #paper-blue-border.MuiPaper-root:hover {
  cursor: pointer;
  box-shadow: 0px 3px 3px -2px rgba(0, 0, 0, 0.2), 0px 3px 4px 0px rgba(0, 0, 0, 0.14), 0px 1px 8px 0px rgba(0, 0, 0, 0.12);
}
@media (max-width: 650px) {
  #home-main-container #video-card-container #paper-gray-border.MuiPaper-root #paper-blue-border.MuiPaper-root {
    width: unset;
    padding: 10px 28px;
  }
}
#home-main-container #video-card-container #paper-gray-border.MuiPaper-root #paper-blue-border.MuiPaper-root .video-text-container {
  margin: 10px 0px;
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
}
#home-main-container #video-card-container #paper-gray-border.MuiPaper-root #paper-blue-border.MuiPaper-root .video-text-container .video {
  margin-left: 20px;
  width: 179px;
  height: 100px;
}
#home-main-container #video-card-container #paper-gray-border.MuiPaper-root #paper-blue-border.MuiPaper-root .video-text-container .home-video-text {
  margin-left: 20px;
  display: flex;
  flex-flow: column nowrap;
  justify-content: flex-start;
}
@media (max-width: 650px) {
  #home-main-container #video-card-container #paper-gray-border.MuiPaper-root #paper-blue-border.MuiPaper-root .video-text-container .home-video-text {
    margin-top: 5px;
  }
}
#home-main-container #video-card-container #paper-gray-border.MuiPaper-root #paper-blue-border.MuiPaper-root .video-text-container .home-video-text .instructor-text {
  display: flex;
  flex-flow: row;
  align-items: center;
  justify-content: flex-start;
}
@media (max-width: 650px) {
  #home-main-container #video-card-container #paper-gray-border.MuiPaper-root #paper-blue-border.MuiPaper-root .video-text-container .home-video-text .instructor-text {
    flex-flow: column nowrap;
    align-items: flex-start;
  }
}
@media (max-width: 650px) {
  #home-main-container #video-card-container #paper-gray-border.MuiPaper-root #paper-blue-border.MuiPaper-root .video-text-container {
    flex-flow: column nowrap;
    align-items: center;
  }
  #home-main-container #video-card-container #paper-gray-border.MuiPaper-root #paper-blue-border.MuiPaper-root .video-text-container .home-video-text,
  #home-main-container #video-card-container #paper-gray-border.MuiPaper-root #paper-blue-border.MuiPaper-root .video-text-container .video {
    margin-left: 0px;
  }
}
#home-main-container #home-grid-parent {
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
}
#home-main-container #home-grid-parent #home-grid-child-one {
  width: 60%;
}
#home-main-container #home-grid-parent #home-grid-child-two {
  width: 29%;
}
#home-main-container #home-grid-parent #home-grid-child-two .spacer {
  height: 143px;
}
@media (max-width: 1279px) {
  #home-main-container #home-grid-parent #home-grid-child-two .spacer {
    display: none;
  }
}
@media (max-width: 1279px) {
  #home-main-container #home-grid-parent {
    flex-flow: column nowrap;
    justify-content: space-evenly;
    align-items: center;
    padding: 0px 71px;
  }
  #home-main-container #home-grid-parent #home-grid-child-one,
  #home-main-container #home-grid-parent #home-grid-child-two {
    width: 100%;
  }
  #home-main-container #home-grid-parent #home-second-stack {
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    align-items: flex-start;
  }
}
@media (max-width: 750px) {
  #home-main-container #home-grid-parent {
    padding: 0px 66px;
  }
  #home-main-container #home-grid-parent #home-second-stack {
    display: flex;
    flex-flow: column nowrap;
    justify-content: flex-start;
    align-items: center;
  }
}
#home-main-container #rd-content-container #paper-gray-border.MuiPaper-root {
  padding: 20px 0px 0px 30px;
}
@media (max-width: 1500px) {
  #home-main-container #rd-content-container #paper-gray-border.MuiPaper-root {
    padding-left: 20px;
  }
}
@media (max-width: 750px) {
  #home-main-container #rd-content-container #paper-gray-border.MuiPaper-root {
    padding: 20px;
  }
}
#home-main-container #rd-content-container .MuiGrid-container {
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
}
#home-main-container #rd-content-container .MuiGrid-container .MuiGrid-item {
  box-sizing: border-box;
  width: 50%;
}
@media (max-width: 1500px) {
  #home-main-container #rd-content-container .MuiGrid-container {
    flex-flow: column nowrap;
    justify-content: flex-start;
  }
  #home-main-container #rd-content-container .MuiGrid-container .MuiGrid-item {
    width: 100%;
  }
}
@media (max-width: 1279px) {
  #home-main-container #rd-content-container {
    width: 47%;
  }
}
@media (max-width: 750px) {
  #home-main-container #rd-content-container {
    width: 100%;
  }
}
#home-main-container #rd-content-container #paper-gray-border.MuiPaper-root {
  padding-bottom: 38px;
}
#home-main-container #help-links-container div.link-row {
  margin: 13px 0px;
  height: 20px;
}
#home-main-container #help-links-container .css-pn6ul1-MuiGrid-root > .MuiGrid-item {
  padding-top: 0px;
}
#home-main-container #help-links-container .css-pn6ul1-MuiGrid-root > .MuiGrid-item {
  margin: 0;
  margin-top: 0px;
}
#home-main-container #help-links-container .MuiPaper-root {
  padding: 12.5px 0px 12px 30px;
}
#home-main-container #help-links-container .MuiGrid-container {
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
}
#home-main-container #help-links-container .MuiGrid-container .MuiGrid-item {
  box-sizing: border-box;
  width: 50%;
}
@media (max-width: 1500px) {
  #home-main-container #help-links-container .MuiGrid-container {
    flex-flow: column nowrap;
    justify-content: flex-start;
  }
  #home-main-container #help-links-container .MuiGrid-container .MuiGrid-item {
    width: 100%;
  }
}
@media (max-width: 1279px) {
  #home-main-container #help-links-container {
    width: 47%;
  }
}
@media (max-width: 750px) {
  #home-main-container #help-links-container {
    width: 100%;
  }
}
#home-main-container #topic-insights-card .css-9mgopn-MuiDivider-root {
  border-color: #909bb3;
}
#home-main-container #topic-insights-card #insights-table .progress-container {
  width: 25%;
  height: 25px;
  margin-right: 5px;
}
#home-main-container #topic-insights-card #insights-table .progress-container .progress {
  height: 100%;
}
#home-main-container #topic-insights-card #insights-table .progress-container .progress-bar {
  background-color: #008cce;
  height: 100%;
}
#home-main-container #topic-insights-card #insights-table .progress-container .progress-bar-striped {
  background-image: linear-gradient(45deg, #2abbff 25%, transparent 25%, transparent 50%, #2abbff 50%, #2abbff 75%, transparent 75%, transparent);
}
#home-main-container #topic-insights-card #insights-table .loading .css-1ex1afd-MuiTableCell-root {
  padding: 0px;
}
#home-main-container #topic-insights-card #insights-table .loader-container {
  width: 100%;
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  justify-content: center;
  background-color: white;
}
#home-main-container #topic-insights-card #insights-table .loader-container img {
  margin: 0 auto;
  width: 42px;
  height: 30px;
}
#home-main-container #topic-insights-card #insights-table div.myrow {
  padding: 8px 9px;
  min-height: 37px;
}
#home-main-container #topic-insights-card #insights-table div.myrow .css-o4b71y-MuiAccordionSummary-content {
  margin: 0px;
}
#home-main-container #topic-insights-card #insights-table div.myrow:not(:last-child) {
  border-bottom: 0.5px solid #909bb3;
}
#home-main-container #topic-insights-card #insights-table div.myrow.accordion-row {
  padding: 0px;
}
#home-main-container #topic-insights-card #insights-table div.myrow .css-o4b71y-MuiAccordionSummary-content.Mui-expanded {
  margin: 0px;
}
#home-main-container #topic-insights-card #insights-table div.myrow .css-sh22l5-MuiButtonBase-root-MuiAccordionSummary-root.Mui-expanded {
  border-bottom: 0.5px solid #909bb3;
}
#home-main-container #topic-insights-card #insights-table div.myrow .css-sh22l5-MuiButtonBase-root-MuiAccordionSummary-root {
  padding: 8px 9px;
  min-height: unset;
}
#home-main-container #topic-insights-card #insights-table div.myrow .css-1elwnq4-MuiPaper-root-MuiAccordion-root {
  box-shadow: none;
}
#home-main-container #topic-insights-card #insights-table div.myrow .css-15v22id-MuiAccordionDetails-root {
  padding: 0px;
}
#home-main-container #topic-insights-card #insights-table div.myrow .css-15wwp11-MuiTableHead-root .css-1ygcj2i-MuiTableCell-root {
  font-family: "Source Sans Pro", sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;
  letter-spacing: 0.0015em;
  color: #373f50;
}
#home-main-container #topic-insights-card #insights-table div.myrow .css-15wwp11-MuiTableHead-root span {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  width: -moz-fit-content;
  width: fit-content;
}
#home-main-container #topic-insights-card #insights-table div.myrow .css-1ygcj2i-MuiTableCell-root,
#home-main-container #topic-insights-card #insights-table div.myrow .css-1ex1afd-MuiTableCell-root {
  padding: 16px 0px;
}
#home-main-container #topic-insights-card #insights-table div.myrow .pl-25 {
  padding-left: 25px;
}
#home-main-container #topic-insights-card #insights-table div.myrow .MuiTooltip-tooltip {
  font-family: "Source Sans Pro", sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 15px;
  display: flex;
  align-items: center;
  text-align: justify;
  background-color: rgb(0, 0, 0);
  color: #ffffff;
}
#home-main-container #generate-insights-card #paper-gray-border {
  padding: 15px 31px 15px 15px;
}
#home-main-container #generate-insights-card .title {
  font-family: "Source Sans Pro", sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  line-height: 30px;
  letter-spacing: 0.0015em;
  margin-bottom: 25px;
  color: #373f50;
}
#home-main-container #generate-insights-card .input-container {
  margin-bottom: 5px;
}
#home-main-container #generate-insights-card .sub-text {
  font-family: "Source Sans Pro", sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 15px;
  /* identical to box height */
  letter-spacing: 0.0015em;
  color: #373f50;
  margin-bottom: 0px;
}
@media (max-width: 1550px) {
  #home-main-container #generate-insights-card .generate-insight-container .insight-input {
    width: 60%;
  }
  #home-main-container #generate-insights-card .generate-insight-container .dropdown-button {
    width: 40%;
  }
}
@media (max-width: 1430px) {
  #home-main-container #generate-insights-card .generate-insight-container .insight-input {
    width: 55%;
  }
  #home-main-container #generate-insights-card .generate-insight-container .dropdown-button {
    width: 45%;
  }
}
@media (max-width: 1335px) {
  #home-main-container #generate-insights-card .generate-insight-container .insight-input {
    width: 50%;
  }
  #home-main-container #generate-insights-card .generate-insight-container .dropdown-button {
    width: 50%;
  }
}
@media (max-width: 1280px) and (max-width: 1550px) {
  #home-main-container #generate-insights-card .generate-insight-container .insight-input {
    width: 60%;
  }
  #home-main-container #generate-insights-card .generate-insight-container .dropdown-button {
    width: 40%;
  }
}
@media (max-width: 1115px) {
  #home-main-container #generate-insights-card .generate-insight-container .insight-input {
    width: 55%;
  }
  #home-main-container #generate-insights-card .generate-insight-container .dropdown-button {
    width: 45%;
  }
}
@media (max-width: 1060px) {
  #home-main-container #generate-insights-card .generate-insight-container .insight-input {
    width: 50%;
  }
  #home-main-container #generate-insights-card .generate-insight-container .dropdown-button {
    width: 50%;
  }
}
@media (max-width: 1014px) {
  #home-main-container #generate-insights-card .generate-insight-container .insight-input {
    width: 55%;
  }
  #home-main-container #generate-insights-card .generate-insight-container .dropdown-button {
    width: 45%;
  }
  #home-main-container #generate-insights-card .generate-insight-container .insight-input,
  #home-main-container #generate-insights-card .generate-insight-container .dropdown-button,
  #home-main-container #generate-insights-card .generate-insight-container .generate-button {
    font-size: 1.6vw;
  }
}
#home-main-container #generate-insights-card #submit-insight-form {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  width: 100%;
  margin: 25px 0px 1px 0px;
}
@media (max-width: 550px) {
  #home-main-container #generate-insights-card #submit-insight-form {
    flex-flow: column;
  }
}
#home-main-container #generate-insights-card #submit-insight-form .generate-insight-label {
  width: 0%;
  color: white;
}
#home-main-container #generate-insights-card #submit-insight-form #generate-insight-input {
  padding: 5px 11px;
  width: 78%;
  margin-right: 2%;
  font-family: "Source Sans Pro", sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  letter-spacing: 0.0015em;
  color: #373f50;
  border: 1px solid #373f50;
  border-radius: 3px;
}
@media (max-width: 950px) {
  #home-main-container #generate-insights-card #submit-insight-form #generate-insight-input {
    width: 70%;
  }
}
@media (max-width: 740px) {
  #home-main-container #generate-insights-card #submit-insight-form #generate-insight-input {
    width: 60%;
  }
}
@media (max-width: 550px) {
  #home-main-container #generate-insights-card #submit-insight-form #generate-insight-input {
    width: 100%;
    margin-bottom: 10px;
  }
}
#home-main-container #generate-insights-card #submit-insight-form .generate-insight-button {
  height: 36px;
  width: 19%;
  background: #008cce;
  color: white;
  border-radius: 3px;
  border: none;
  font-family: "Source Sans Pro", sans-serif;
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;
  letter-spacing: 0.0125em;
  text-transform: capitalize;
  color: #ffffff;
}
@media (max-width: 950px) {
  #home-main-container #generate-insights-card #submit-insight-form .generate-insight-button {
    width: 37%;
  }
}
@media (max-width: 740px) {
  #home-main-container #generate-insights-card #submit-insight-form .generate-insight-button {
    width: 47%;
  }
}
@media (max-width: 550px) {
  #home-main-container #generate-insights-card #submit-insight-form .generate-insight-button {
    width: 90%;
  }
}

@media (max-width: 450px) {
  .MuiChip-root {
    font-size: 9px;
  }
}

.progress-bar {
  background-color: #008cce;
}`, "",{"version":3,"sources":["webpack://./src/components/home/home.scss"],"names":[],"mappings":"AAOE;EACE,UAAA;AANJ;AAQE;EACE,UAAA;AANJ;AAQE;EACE,2BAAA;EACA,kBAAA;EACA,WAAA;EACA,0CAAA;EACA,cAAA;AANJ;AASE;EACE,iBAAA;EACA,iBAAA;EACA,cAAA;EACA,wCAAA;EACA,aAAA;EACA,wBAAA;EACA,uBAAA;AAPJ;AAQI;EARF;IASI,mBAAA;EALJ;EAMI;IACE,kBAAA;EAJN;AACF;AAMI;EACE,eAAA;EACA,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;AAJN;AASI;EACE,4BAAA;AAPN;AAQM;EAFF;IAGI,mBAAA;EALN;AACF;AAOI;EACE,aAAA;EACA,wBAAA;EACA,uBAAA;AALN;AAMM;EACE,0CAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,wBAAA;EACA,cAAA;EACA,kBAAA;AAJR;AAMM;EACE,0CAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,wBAAA;EACA,cAAA;AAJR;AAKQ;EACE,cAAA;EACA,gBAAA;EACA,eAAA;AAHV;AAOM;EA7BF;IA8BI,qBAAA;IACA,mBAAA;EAJN;EAKM;IACE,kBAAA;IACA,gBAAA;EAHR;EAKM;IACE,mBAAA;IACA,eAAA;IACA,kBAAA;EAHR;EAKM;IACE,mBAAA;EAHR;AACF;AAKM;EA7CF;IA8CI,wBAAA;IACA,uBAAA;EAFN;EAGM;IACE,mBAAA;EADR;AACF;AAMI;EACE,2BAAA;AAJN;AAKM;EAFF;IAGI,kBAAA;EAFN;AACF;AAGM;EALF;IAMI,4BAAA;IACA,aAAA;IACA,wBAAA;IACA,mBAAA;EAAN;EACM;IACE,mBAAA;EACR;EACM;IACE,sBAAA;EACR;AACF;AAEQ;EADF;IAEI,WAAA;IACA,aAAA;IACA,wBAAA;IACA,mBAAA;EACR;AACF;AACM;EACE,yBAAA;EACA,gBAAA;EACA,UAAA;EACA,kBAAA;AACR;AAAQ;EACE,eAAA;EACA,yHAAA;AAEV;AAEQ;EAXF;IAYI,YAAA;IACA,kBAAA;EACR;AACF;AAAQ;EACE,gBAAA;EACA,aAAA;EACA,qBAAA;EACA,2BAAA;AAEV;AAAU;EACE,iBAAA;EACA,YAAA;EACA,aAAA;AAEZ;AAAU;EACE,iBAAA;EACA,aAAA;EACA,wBAAA;EACA,2BAAA;AAEZ;AADY;EALF;IAMI,eAAA;EAIZ;AACF;AAHY;EACE,aAAA;EACA,cAAA;EACA,mBAAA;EACA,2BAAA;AAKd;AAJc;EALF;IAMI,wBAAA;IACA,uBAAA;EAOd;AACF;AAJU;EA9BF;IA+BI,wBAAA;IACA,mBAAA;EAOV;EANU;;IAEE,gBAAA;EAQZ;AACF;AAFE;EACE,aAAA;EACA,qBAAA;EACA,uBAAA;AAIJ;AAHI;EACE,UAAA;AAKN;AAHI;EACE,UAAA;AAKN;AAJM;EACE,aAAA;AAMR;AALQ;EAFF;IAGI,aAAA;EAQR;AACF;AAII;EAzBF;IA0BI,wBAAA;IACA,6BAAA;IACA,mBAAA;IACA,iBAAA;EADJ;EAEI;;IAEE,WAAA;EAAN;EAEI;IACE,aAAA;IACA,qBAAA;IACA,8BAAA;IACA,uBAAA;EAAN;AACF;AAEI;EAzCF;IA0CI,iBAAA;EACJ;EAAI;IACE,aAAA;IACA,wBAAA;IACA,2BAAA;IACA,mBAAA;EAEN;AACF;AAGI;EACE,0BAAA;AADN;AAEM;EAFF;IAGI,kBAAA;EACN;AACF;AAAM;EALF;IAMI,aAAA;EAGN;AACF;AAAI;EACE,aAAA;EACA,qBAAA;EACA,2BAAA;AAEN;AADM;EACE,sBAAA;EACA,UAAA;AAGR;AAAM;EATF;IAUI,wBAAA;IACA,2BAAA;EAGN;EAFM;IACE,WAAA;EAIR;AACF;AADI;EA5BF;IA6BI,UAAA;EAIJ;AACF;AAHI;EA/BF;IAgCI,WAAA;EAMJ;AACF;AAHI;EACE,oBAAA;AAKN;AADI;EACE,gBAAA;EACA,YAAA;AAGN;AAAI;EACE,gBAAA;AAEN;AAAI;EACE,SAAA;EACA,eAAA;AAEN;AAAI;EACE,6BAAA;AAEN;AAAI;EACE,aAAA;EACA,qBAAA;EACA,2BAAA;AAEN;AADM;EACE,sBAAA;EACA,UAAA;AAGR;AAAM;EATF;IAUI,wBAAA;IACA,2BAAA;EAGN;EAFM;IACE,WAAA;EAIR;AACF;AADI;EAjCF;IAkCI,UAAA;EAIJ;AACF;AAHI;EApCF;IAqCI,WAAA;EAMJ;AACF;AAHI;EACE,qBA/TO;AAoUb;AADM;EACE,UAAA;EACA,YAAA;EACA,iBAAA;AAGR;AAFQ;EACE,YAAA;AAIV;AAFQ;EACE,yBA/UQ;EAgVR,YAAA;AAIV;AADQ;EACE,+IAAA;AAGV;AAUQ;EACE,YAAA;AARV;AAWM;EACE,WAAA;EAGA,aAAA;EACA,wBAAA;EACA,mBAAA;EACA,uBAAA;EACA,uBAAA;AAXR;AAYQ;EACE,cAAA;EACA,WAAA;EACA,YAAA;AAVV;AAaM;EACE,gBAAA;EACA,gBAAA;AAXR;AAYQ;EACE,WAAA;AAVV;AAYQ;EACE,kCAAA;AAVV;AAYQ;EACE,YAAA;AAVV;AAYQ;EACE,WAAA;AAVV;AAYQ;EACE,kCAAA;AAVV;AAYQ;EACE,gBAAA;EACA,iBAAA;AAVV;AAYQ;EACE,gBAAA;AAVV;AAaQ;EACE,YAAA;AAXV;AAeU;EACE,0CAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,wBAAA;EACA,cAAA;AAbZ;AAiBU;EACE,aAAA;EACA,qBAAA;EACA,mBAAA;EACA,uBAAA;EAAA,kBAAA;AAfZ;AAkBQ;;EAEE,iBAAA;AAhBV;AAkBQ;EACE,kBAAA;AAhBV;AAmBQ;EACE,0CAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,8BAAA;EACA,cAAA;AAjBV;AAwBI;EACE,4BAAA;AAtBN;AAwBI;EACE,0CAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,wBAAA;EACA,mBAAA;EAEA,cAAA;AAvBN;AAyBI;EACE,kBAAA;AAvBN;AAyBI;EACE,0CAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,4BAAA;EAEA,wBAAA;EAEA,cAAA;EACA,kBAAA;AAzBN;AA4BM;EACE;IACE,UAAA;EA1BR;EA4BM;IACE,UAAA;EA1BR;AACF;AA4BM;EACE;IACE,UAAA;EA1BR;EA4BM;IACE,UAAA;EA1BR;AACF;AA4BM;EACE;IACE,UAAA;EA1BR;EA4BM;IACE,UAAA;EA1BR;AACF;AA6BQ;EACE;IACE,UAAA;EA3BV;EA6BQ;IACE,UAAA;EA3BV;AACF;AA8BM;EACE;IACE,UAAA;EA5BR;EA8BM;IACE,UAAA;EA5BR;AACF;AA8BM;EACE;IACE,UAAA;EA5BR;EA8BM;IACE,UAAA;EA5BR;AACF;AA8BM;EACE;IACE,UAAA;EA5BR;EA8BM;IACE,UAAA;EA5BR;EA8BM;;;IAGE,gBAAA;EA5BR;AACF;AA+BI;EACE,aAAA;EACA,qBAAA;EACA,mBAAA;EACA,WAAA;EACA,wBAAA;AA7BN;AA8BM;EANF;IAOI,iBAAA;EA3BN;AACF;AA4BM;EACE,SAAA;EACA,YAAA;AA1BR;AA4BM;EACE,iBAAA;EACA,UAAA;EACA,gBAAA;EACA,0CAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,wBAAA;EACA,cAAA;EACA,yBAAA;EACA,kBAAA;AA1BR;AA2BQ;EAZF;IAaI,UAAA;EAxBR;AACF;AAyBQ;EAfF;IAgBI,UAAA;EAtBR;AACF;AAuBQ;EAlBF;IAmBI,WAAA;IACA,mBAAA;EApBR;AACF;AAsBM;EACE,YAAA;EACA,UAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,0CAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,wBAAA;EACA,0BAAA;EACA,cAAA;AApBR;AAqBQ;EAdF;IAeI,UAAA;EAlBR;AACF;AAmBQ;EAjBF;IAkBI,UAAA;EAhBR;AACF;AAiBQ;EApBF;IAqBI,UAAA;EAdR;AACF;;AAqBE;EADF;IAEI,cAAA;EAjBF;AACF;;AAoBA;EACE,yBApmBgB;AAmlBlB","sourcesContent":["$demandjump-blue: #008cce;\n$demandjump-green: #44af69;\n$secondary-tint-1: #e9ebf0;\n$metal-gray: #373f50;\n$light-gray: #909bb3;\n\n#home-main-container {\n  .w-75 {\n    width: 75%;\n  }\n  .w-25 {\n    width: 25%;\n  }\n  #paper-gray-border.MuiPaper-root {\n    border: 0.5px solid #909bb3;\n    border-radius: 8px;\n    width: 100%;\n    font-family: \"Source Sans Pro\", sans-serif;\n    color: #373f50;\n  }\n\n  .welcome-card-container {\n    min-height: 143px;\n    padding-top: 35px;\n    color: #373f50;\n    font-family: Source Sans Pro, sans-serif;\n    display: flex;\n    flex-flow: column nowrap;\n    align-items: flex-start;\n    @media (max-width: 750px) {\n      align-items: center;\n      div {\n        text-align: center;\n      }\n    }\n    .name-container {\n      font-size: 48px;\n      display: inline-block;\n      max-width: 100%;\n      overflow: hidden;\n      white-space: nowrap;\n      text-overflow: ellipsis;\n    }\n  }\n\n  #dj-uni-card-container {\n    #paper-gray-border.MuiPaper-root {\n      padding: 21px 50px 20px 24px;\n      @media (max-width: 1500px) {\n        padding-right: 20px;\n      }\n    }\n    .flex-container {\n      display: flex;\n      flex-flow: column nowrap;\n      align-items: flex-start;\n      .card-header {\n        font-family: \"Source Sans Pro\", sans-serif;\n        font-style: normal;\n        font-weight: 600;\n        font-size: 24px;\n        line-height: 30px;\n        letter-spacing: 0.0015em;\n        color: #373f50;\n        margin-bottom: 9px;\n      }\n      .body-text {\n        font-family: \"Source Sans Pro\", sans-serif;\n        font-style: normal;\n        font-weight: 400;\n        font-size: 14px;\n        line-height: 18px;\n        letter-spacing: 0.0015em;\n        color: #373f50;\n        .card-link {\n          color: #008cce;\n          font-weight: 600;\n          cursor: pointer;\n        }\n      }\n\n      @media (max-width: 1500px) {\n        flex-flow: row nowrap;\n        align-items: center;\n        .icon-hyperlink {\n          margin-bottom: 0px;\n          min-width: 200px;\n        }\n        .card-header {\n          white-space: nowrap;\n          font-size: 16px;\n          margin-right: 10px;\n        }\n        .body-text {\n          text-align: justify;\n        }\n      }\n      @media (max-width: 750px) {\n        flex-flow: column nowrap;\n        align-items: flex-start;\n        .icon-hyperlink {\n          margin-bottom: 14px;\n        }\n      }\n    }\n  }\n  #video-card-container {\n    #paper-gray-border.MuiPaper-root {\n      padding: 20px 0px 28px 20px;\n      @media (max-width: 1279px) {\n        padding-left: 20px;\n      }\n      @media (max-width: 650px) {\n        padding: 20px 20px 28px 20px;\n        display: flex;\n        flex-flow: column nowrap;\n        align-items: center;\n        div {\n          text-align: justify;\n        }\n        #video-card-header {\n          align-self: flex-start;\n        }\n      }\n      #video-blue-paper-wrapper {\n        @media (max-width: 650px) {\n          width: 100%;\n          display: flex;\n          flex-flow: column nowrap;\n          align-items: center;\n        }\n      }\n      #paper-blue-border.MuiPaper-root {\n        border: 1px solid #008cce;\n        margin: 20px 0px;\n        width: 81%;\n        border-radius: 8px;\n        &:hover {\n          cursor: pointer;\n          box-shadow: 0px 3px 3px -2px rgba(0, 0, 0, 0.2),\n            0px 3px 4px 0px rgba(0, 0, 0, 0.14),\n            0px 1px 8px 0px rgba(0, 0, 0, 0.12);\n        }\n        @media (max-width: 650px) {\n          width: unset;\n          padding: 10px 28px;\n        }\n        .video-text-container {\n          margin: 10px 0px;\n          display: flex;\n          flex-flow: row nowrap;\n          justify-content: flex-start;\n\n          .video {\n            margin-left: 20px;\n            width: 179px;\n            height: 100px;\n          }\n          .home-video-text {\n            margin-left: 20px;\n            display: flex;\n            flex-flow: column nowrap;\n            justify-content: flex-start;\n            @media (max-width: 650px) {\n              margin-top: 5px;\n            }\n            .instructor-text {\n              display: flex;\n              flex-flow: row;\n              align-items: center;\n              justify-content: flex-start;\n              @media (max-width: 650px) {\n                flex-flow: column nowrap;\n                align-items: flex-start;\n              }\n            }\n          }\n          @media (max-width: 650px) {\n            flex-flow: column nowrap;\n            align-items: center;\n            .home-video-text,\n            .video {\n              margin-left: 0px;\n            }\n          }\n        }\n      }\n    }\n  }\n  #home-grid-parent {\n    display: flex;\n    flex-flow: row nowrap;\n    justify-content: center;\n    #home-grid-child-one {\n      width: 60%;\n    }\n    #home-grid-child-two {\n      width: 29%;\n      .spacer {\n        height: 143px;\n        @media (max-width: 1279px) {\n          display: none;\n        }\n      }\n    }\n    // @media (max-width: 1500px) {\n    //     #home-grid-child-one {\n    //         width: 49vw;\n    //     }\n    //     #home-grid-child-two {\n    //         width: 22vw;\n    //     }\n\n    // }\n    @media (max-width: 1279px) {\n      flex-flow: column nowrap;\n      justify-content: space-evenly;\n      align-items: center;\n      padding: 0px 71px;\n      #home-grid-child-one,\n      #home-grid-child-two {\n        width: 100%;\n      }\n      #home-second-stack {\n        display: flex;\n        flex-flow: row nowrap;\n        justify-content: space-between;\n        align-items: flex-start;\n      }\n    }\n    @media (max-width: 750px) {\n      padding: 0px 66px;\n      #home-second-stack {\n        display: flex;\n        flex-flow: column nowrap;\n        justify-content: flex-start;\n        align-items: center;\n      }\n    }\n  }\n\n  #rd-content-container {\n    #paper-gray-border.MuiPaper-root {\n      padding: 20px 0px 0px 30px;\n      @media (max-width: 1500px) {\n        padding-left: 20px;\n      }\n      @media (max-width: 750px) {\n        padding: 20px;\n      }\n    }\n\n    .MuiGrid-container {\n      display: flex;\n      flex-flow: row nowrap;\n      justify-content: flex-start;\n      .MuiGrid-item {\n        box-sizing: border-box;\n        width: 50%;\n      }\n\n      @media (max-width: 1500px) {\n        flex-flow: column nowrap;\n        justify-content: flex-start;\n        .MuiGrid-item {\n          width: 100%;\n        }\n      }\n    }\n    @media (max-width: 1279px) {\n      width: 47%;\n    }\n    @media (max-width: 750px) {\n      width: 100%;\n    }\n  }\n  #rd-content-container {\n    #paper-gray-border.MuiPaper-root {\n      padding-bottom: 38px;\n    }\n  }\n  #help-links-container {\n    div.link-row {\n      margin: 13px 0px;\n      height: 20px;\n    }\n\n    .css-pn6ul1-MuiGrid-root > .MuiGrid-item {\n      padding-top: 0px;\n    }\n    .css-pn6ul1-MuiGrid-root > .MuiGrid-item {\n      margin: 0;\n      margin-top: 0px;\n    }\n    .MuiPaper-root {\n      padding: 12.5px 0px 12px 30px;\n    }\n    .MuiGrid-container {\n      display: flex;\n      flex-flow: row nowrap;\n      justify-content: flex-start;\n      .MuiGrid-item {\n        box-sizing: border-box;\n        width: 50%;\n      }\n\n      @media (max-width: 1500px) {\n        flex-flow: column nowrap;\n        justify-content: flex-start;\n        .MuiGrid-item {\n          width: 100%;\n        }\n      }\n    }\n    @media (max-width: 1279px) {\n      width: 47%;\n    }\n    @media (max-width: 750px) {\n      width: 100%;\n    }\n  }\n  #topic-insights-card {\n    .css-9mgopn-MuiDivider-root {\n      border-color: $light-gray;\n    }\n\n    #insights-table {\n      .progress-container {\n        width: 25%;\n        height: 25px;\n        margin-right: 5px;\n        .progress {\n          height: 100%;\n        }\n        .progress-bar {\n          background-color: $demandjump-blue;\n          height: 100%;\n        }\n\n        .progress-bar-striped {\n          background-image: linear-gradient(\n            45deg,\n            #2abbff 25%,\n            transparent 25%,\n            transparent 50%,\n            #2abbff 50%,\n            #2abbff 75%,\n            transparent 75%,\n            transparent\n          );\n        }\n      }\n      .loading {\n        .css-1ex1afd-MuiTableCell-root {\n          padding: 0px;\n        }\n      }\n      .loader-container {\n        width: 100%;\n        // height: 500px;\n        // max-height: 424px;\n        display: flex;\n        flex-flow: column nowrap;\n        align-items: center;\n        justify-content: center;\n        background-color: white;\n        img {\n          margin: 0 auto;\n          width: 42px;\n          height: 30px;\n        }\n      }\n      div.myrow {\n        padding: 8px 9px;\n        min-height: 37px;\n        .css-o4b71y-MuiAccordionSummary-content {\n          margin: 0px;\n        }\n        &:not(:last-child) {\n          border-bottom: 0.5px solid $light-gray;\n        }\n        &.accordion-row {\n          padding: 0px;\n        }\n        .css-o4b71y-MuiAccordionSummary-content.Mui-expanded {\n          margin: 0px;\n        }\n        .css-sh22l5-MuiButtonBase-root-MuiAccordionSummary-root.Mui-expanded {\n          border-bottom: 0.5px solid $light-gray;\n        }\n        .css-sh22l5-MuiButtonBase-root-MuiAccordionSummary-root {\n          padding: 8px 9px;\n          min-height: unset;\n        }\n        .css-1elwnq4-MuiPaper-root-MuiAccordion-root {\n          box-shadow: none;\n        }\n\n        .css-15v22id-MuiAccordionDetails-root {\n          padding: 0px;\n        }\n\n        .css-15wwp11-MuiTableHead-root {\n          .css-1ygcj2i-MuiTableCell-root {\n            font-family: \"Source Sans Pro\", sans-serif;\n            font-style: normal;\n            font-weight: 600;\n            font-size: 16px;\n            line-height: 20px;\n            letter-spacing: 0.0015em;\n            color: #373f50;\n          }\n        }\n        .css-15wwp11-MuiTableHead-root {\n          span {\n            display: flex;\n            flex-flow: row nowrap;\n            align-items: center;\n            width: fit-content;\n          }\n        }\n        .css-1ygcj2i-MuiTableCell-root,\n        .css-1ex1afd-MuiTableCell-root {\n          padding: 16px 0px;\n        }\n        .pl-25 {\n          padding-left: 25px;\n        }\n\n        .MuiTooltip-tooltip {\n          font-family: \"Source Sans Pro\", sans-serif;\n          font-style: normal;\n          font-weight: 400;\n          font-size: 12px;\n          line-height: 15px;\n          display: flex;\n          align-items: center;\n          text-align: justify;\n          background-color: rgba(0, 0, 0, 1);\n          color: #ffffff;\n        }\n      }\n    }\n  }\n\n  #generate-insights-card {\n    #paper-gray-border {\n      padding: 15px 31px 15px 15px;\n    }\n    .title {\n      font-family: \"Source Sans Pro\", sans-serif;\n      font-style: normal;\n      font-weight: 600;\n      font-size: 24px;\n      line-height: 30px;\n      letter-spacing: 0.0015em;\n      margin-bottom: 25px;\n\n      color: #373f50;\n    }\n    .input-container {\n      margin-bottom: 5px;\n    }\n    .sub-text {\n      font-family: \"Source Sans Pro\", sans-serif;\n      font-style: normal;\n      font-weight: 400;\n      font-size: 12px;\n      line-height: 15px;\n      /* identical to box height */\n\n      letter-spacing: 0.0015em;\n\n      color: #373f50;\n      margin-bottom: 0px;\n    }\n    .generate-insight-container {\n      @media (max-width: 1550px) {\n        .insight-input {\n          width: 60%;\n        }\n        .dropdown-button {\n          width: 40%;\n        }\n      }\n      @media (max-width: 1430px) {\n        .insight-input {\n          width: 55%;\n        }\n        .dropdown-button {\n          width: 45%;\n        }\n      }\n      @media (max-width: 1335px) {\n        .insight-input {\n          width: 50%;\n        }\n        .dropdown-button {\n          width: 50%;\n        }\n      }\n      @media (max-width: 1280px) {\n        @media (max-width: 1550px) {\n          .insight-input {\n            width: 60%;\n          }\n          .dropdown-button {\n            width: 40%;\n          }\n        }\n      }\n      @media (max-width: 1115px) {\n        .insight-input {\n          width: 55%;\n        }\n        .dropdown-button {\n          width: 45%;\n        }\n      }\n      @media (max-width: 1060px) {\n        .insight-input {\n          width: 50%;\n        }\n        .dropdown-button {\n          width: 50%;\n        }\n      }\n      @media (max-width: 1014px) {\n        .insight-input {\n          width: 55%;\n        }\n        .dropdown-button {\n          width: 45%;\n        }\n        .insight-input,\n        .dropdown-button,\n        .generate-button {\n          font-size: 1.6vw;\n        }\n      }\n    }\n    #submit-insight-form {\n      display: flex;\n      flex-flow: row nowrap;\n      align-items: center;\n      width: 100%;\n      margin: 25px 0px 1px 0px;\n      @media (max-width: 550px) {\n        flex-flow: column;\n      }\n      .generate-insight-label {\n        width: 0%;\n        color: white;\n      }\n      #generate-insight-input {\n        padding: 5px 11px;\n        width: 78%;\n        margin-right: 2%;\n        font-family: \"Source Sans Pro\", sans-serif;\n        font-style: normal;\n        font-weight: 400;\n        font-size: 16px;\n        letter-spacing: 0.0015em;\n        color: #373f50;\n        border: 1px solid #373f50;\n        border-radius: 3px;\n        @media (max-width: 950px) {\n          width: 70%;\n        }\n        @media (max-width: 740px) {\n          width: 60%;\n        }\n        @media (max-width: 550px) {\n          width: 100%;\n          margin-bottom: 10px;\n        }\n      }\n      .generate-insight-button {\n        height: 36px;\n        width: 19%;\n        background: #008cce;\n        color: white;\n        border-radius: 3px;\n        border: none;\n        font-family: \"Source Sans Pro\", sans-serif;\n        font-weight: 600;\n        font-size: 16px;\n        line-height: 20px;\n        letter-spacing: 0.0125em;\n        text-transform: capitalize;\n        color: #ffffff;\n        @media (max-width: 950px) {\n          width: 37%;\n        }\n        @media (max-width: 740px) {\n          width: 47%;\n        }\n        @media (max-width: 550px) {\n          width: 90%;\n        }\n      }\n    }\n  }\n}\n\n.MuiChip-root {\n  @media (max-width: 450px) {\n    font-size: 9px;\n  }\n}\n\n.progress-bar {\n  background-color: $demandjump-blue;\n}\n\n// .progress-bar-striped {\n//   background-image: linear-gradient(45deg, #2ABBFF 25%, transparent 25%, transparent 50%, #2ABBFF 50%, #2ABBFF 75%, transparent 75%, transparent);\n// }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
